/** Strip markdown syntax for teasers, search excerpts, and plain-text previews. */
export function stripCommunityPostMarkdown(content: string): string {
  let text = content;

  text = text.replace(/```[\s\S]*?```/g, (match) => {
    const inner = match.replace(/^```[^\n]*\n?/, '').replace(/\n?```$/, '');
    return inner.trim() || '[code]';
  });
  text = text.replace(/`([^`\n]+)`/g, '$1');
  text = text.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '$1');
  text = text.replace(/!\[([^\]]*)\]\(([^)]+)\)/g, '$1');
  text = text.replace(/<https?:\/\/[^>\s]+>/gi, (match) => match.slice(1, -1));
  text = text.replace(/^#{1,6}\s+/gm, '');
  text = text.replace(/^\s*[-*+]\s+/gm, '');
  text = text.replace(/^\s*\d+\.\s+/gm, '');
  text = text.replace(/\*\*([^*]+)\*\*/g, '$1');
  text = text.replace(/\*([^*]+)\*/g, '$1');
  text = text.replace(/__([^_]+)__/g, '$1');
  text = text.replace(/_([^_]+)_/g, '$1');
  text = text.replace(/<[^>\n]+>/g, '');

  return text.replace(/\n{3,}/g, '\n\n').trim();
}

export function containsUnsafeCommunityPostHtml(content: string): boolean {
  return /<\s*\/?\s*[a-z][^>]*>/i.test(content);
}
